<template>
    <svg
        viewBox="0 0 640 300"
        xmlns="http://www.w3.org/2000/svg"
        :class="$css($theme.strokePrimary)"
        :style="`width: ${width}px;`"
    >
        <path
            :d="pagePath"
            class="page-5"
        />

        <path
            :d="pagePath"
            class="page-4"
        />

        <path
            :d="pagePath"
            class="page-3"
        />

        <path
            :d="pagePath"
            class="page-2"
        />

        <path
            :d="pagePath"
            class="page-1"
        />

        <path
            d="M 354,252 H 519"
            class="page-6"
        />

        <path
            d="M 320,240 V 195 H 545"
            class="top-cover"
        />

        <path
            d="m 320,240 v 45 h 225"
            class="bottom-cover"
        />
    </svg>
</template>

<script>
export default {
    props: {
        width: {
            default: 150,
            type: Number,
        },
    },

    computed: {
        pagePath() {
            return "M 354,228 H 519"
        },
    },
}
</script>

<style scoped>
svg {
    fill: none;
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 4;
    stroke-dasharray: none;
    stroke-opacity: 1;
}

path {
    animation-delay: 0s;
    animation-direction: alternate;
    animation-duration: 1.85s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in;
    transform-origin: 320px 240px;
}

.top-cover {
    animation-name: top-cover;
}
.bottom-cover {
    animation-name: bottom-cover;
}
.page-1 {
    animation-name: p1;
}
.page-2 {
    animation-name: p2;
}
.page-3 {
    animation-name: p3;
}
.page-4 {
    animation-name: p4;
}
.page-5 {
    animation-name: p5;
}
.page-6 {
    animation-name: p6;
}

@keyframes top-cover {
    0% {
        rotate: 0deg;
    }
    10% {
        rotate: 0deg;
    }
    30% {
        rotate: -180deg;
    }
    70% {
        rotate: -180deg;
    }
    100% {
        rotate: -180deg;
    }
}

@keyframes p1 {
    0% {
        rotate: 0deg;
    }
    10% {
        rotate: 0deg;
    }
    40% {
        rotate: -180deg;
    }
    90% {
        rotate: -180deg;
    }
    100% {
        rotate: -180deg;
    }
}

@keyframes p2 {
    0% {
        rotate: 0deg;
    }
    20% {
        rotate: 0deg;
    }
    48% {
        rotate: -180deg;
    }
    90% {
        rotate: -180deg;
    }
    100% {
        rotate: -180deg;
    }
}

@keyframes p3 {
    0% {
        rotate: 0deg;
    }
    30% {
        rotate: 0deg;
    }
    56% {
        rotate: -180deg;
    }
    90% {
        rotate: -180deg;
    }
    100% {
        rotate: -180deg;
    }
}

@keyframes p4 {
    0% {
        rotate: 0deg;
    }
    40% {
        rotate: 0deg;
    }
    64% {
        rotate: -180deg;
    }
    90% {
        rotate: -180deg;
    }
    100% {
        rotate: -180deg;
    }
}

@keyframes p5 {
    0% {
        rotate: 0deg;
    }
    50% {
        rotate: 0deg;
    }
    72% {
        rotate: -180deg;
    }
    90% {
        rotate: -180deg;
    }
    100% {
        rotate: -180deg;
    }
}

@keyframes p6 {
    0% {
        rotate: 0deg;
    }
    60% {
        rotate: 0deg;
    }
    80% {
        rotate: -180deg;
    }
    90% {
        rotate: -180deg;
    }
    100% {
        rotate: -180deg;
    }
}

@keyframes bottom-cover {
    0% {
        rotate: 0deg;
    }
    70% {
        rotate: 0deg;
    }
    90% {
        rotate: -180deg;
    }
    100% {
        rotate: -180deg;
    }
}
</style>
